import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const AttachmentsNavigationWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const NavigationSummary = styled.div`
  margin-right: ${Spacing.S4};
  margin-left: ${Spacing.S4};
`
